import { Button } from '@/components/Button'
import type { ActionId } from '@/annotations'

/**
 * `div.save-bar` → `save-bar` (process/08-COMPONENT-CATALOGUE.md). `D90`, first drawn on `v-notify`
 * (W133): "every editable settings panel commits on its own explicit `Save changes`/`Cancel` pair,
 * never on blur" — one shared component now that a second, third and fourth screen
 * (`v-setgeneral`, `v-credential`) repeat the identical pair.
 */
export function SaveBar({
  dataAct,
  dirty,
  pending,
  danger,
  saveLabel = 'Save changes',
  onSave,
  onCancel,
}: {
  dataAct: ActionId | undefined
  dirty: boolean
  pending: boolean
  danger?: boolean
  saveLabel?: string
  onSave: () => void
  onCancel: () => void
}) {
  return (
    <div data-cmp="save-bar" className="flex gap-4 justify-end mt-6">
      <Button data-act={undefined} ghost disabled={!dirty || pending} onClick={onCancel}>
        Cancel
      </Button>
      <Button data-act={dataAct} danger={danger} disabled={!dirty || pending} onClick={onSave}>
        {pending ? 'Saving…' : saveLabel}
      </Button>
    </div>
  )
}
